import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from '../components/Sidebar';
import { BottomNav } from '../components/BottomNav';
import { Topbar } from '../components/Topbar';
import { useAuthStore } from '../auth/store';
import { useTheme } from '../lib/useTheme';

function screenMeta(path: string) {
  if (path.startsWith('/earnings')) return { eyebrow: 'Affiliate · Snapmon', title: 'Earnings & payouts' };
  if (path.startsWith('/subscribers')) return { eyebrow: 'Affiliate · Snapmon', title: 'Your subscribers' };
  return { eyebrow: 'Affiliate · Snapmon', title: 'Overview' };
}

export function ShellLayout() {
  const location = useLocation();
  const creator = useAuthStore((s) => s.creator);
  // Apply the persisted light/dark theme to <body> on every authenticated page.
  useTheme();
  const meta = screenMeta(location.pathname);
  const titleWithName = location.pathname === '/' && creator
    ? `Welcome back, ${creator.name.split(' ')[0]}`
    : meta.title;

  return (
    <div className="app">
      <Sidebar />
      <main style={{ minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <Topbar
          eyebrow={meta.eyebrow}
          title={titleWithName}
          right={
            <>
              {creator && (
                <div
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: '50%',
                    background: 'var(--brand)',
                    color: 'var(--bg-elev)',
                    display: 'grid',
                    placeItems: 'center',
                    fontFamily: 'var(--font-display)',
                    fontWeight: 700,
                    fontSize: 13,
                  }}
                >
                  {creator.avatarInitials}
                </div>
              )}
            </>
          }
        />
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
